import { render } from "./BaugrundstueckStep1.vue?vue&type=template&id=685a9339&scoped=true"
import script from "./BaugrundstueckStep1.vue?vue&type=script&lang=js"
export * from "./BaugrundstueckStep1.vue?vue&type=script&lang=js"

import "./BaugrundstueckStep1.vue?vue&type=style&index=0&id=685a9339&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685a9339"]])

export default __exports__